import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';

import { Dashboard } from '../models/core.models';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { WidgetViewProperties } from './feed.service';
import { buildHttpParams } from 'src/app/shared/http-params-builder';

export interface CopyDashboardParams {
  workspace_id: string;

  // Single or multi dashboard copy
  object_ids: string[];

  // Used when copying one dashboard
  title?: string;
  description?: string;

  // Used when copying multiple dashboards
  prefix?: string;

  duplicateExportSchedules?: boolean;
  duplicatePermissions?: boolean;
}

export interface CopyDashboardResponse {
  dashboards: Dashboard[];
}

@Injectable({
  providedIn: 'root',
})
export class DashboardService {
  constructor(private http: HttpClient) {}

  saveDashboardSettings(
    dashboardId: string,
    viewProperties: WidgetViewProperties,
  ) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
    });

    let httpParams = buildHttpParams({ viewProperties });

    // Make the HTTP PATCH request with the URL-encoded parameters
    return this.http.patch(
      `/dashboard/${dashboardId}/context_menu_options`,
      httpParams,
      {
        headers,
      },
    );
  }

  /**
   * Duplicate one or more dashboards.
   *
   * Backend: DashboardPOST::copyDashboard()
   */
  copyDashboard(
    params: CopyDashboardParams,
  ): Observable<CopyDashboardResponse> {
    return this.http.post<CopyDashboardResponse>(
      `/dashboard/copy_dashboard`,
      params,
    );
  }
}
